import React, { FC } from 'react';
import { Typography, Stack, Link } from '@mui/material';
import { formatDateOnly } from '../Formatters';
import { useQuery } from '@apollo/client';
import LoadingSpinner from '../LoadingSpinner';
import { StyledPaper } from '../theme';
import { useUserContext } from '../UserContext';
import { GET_COMMENTS_ON_GUIDES_FOR_USER } from './home.graphql';
import { GetCommentsOnGuidesForUserQuery } from '../__generated__/graphql';
import { Unpacked } from '../graphQLTypes/types';
import { Link as RouterLink } from 'react-router-dom';

export const CommentsOnMyGuides: FC<{ numberOfComments?: number }> = ({ numberOfComments = 5 }) => {
  const { userId } = useUserContext();
  const { data } = useQuery(GET_COMMENTS_ON_GUIDES_FOR_USER, {
    variables: { ownerId: userId, take: numberOfComments },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <StyledPaper>
      <Typography variant="h5" component="h3">
        Kommentarer på mine anvisninger
      </Typography>
      <Typography color="textSecondary" fontSize="small" component="p">
        Siste {numberOfComments} kommentarer på anvisninger du er ansvarlig for
      </Typography>
      {!data && <LoadingSpinner />}
      {data?.comments && (
        <Stack spacing={2} mt={2}>
          {data.comments.nodes?.filter((x) => !!x).map((c) => <CommentItem key={c?.id} comment={c} />)}
        </Stack>
      )}
    </StyledPaper>
  );
};

type Comment = NonNullable<NonNullable<Unpacked<NonNullable<GetCommentsOnGuidesForUserQuery['comments']>['nodes']>>>;
const CommentItem: FC<{ comment: Comment }> = ({ comment }) => {
  return (
    <Stack spacing={1}>
      <Stack spacing={1} alignItems="center" justifyContent="space-between" direction="row">
        <Link component={RouterLink} to={`/guide/${comment.guide?.id}#comment-${comment.id}`}>
          {comment.guide?.docName} {comment.guide?.docTitle}
        </Link>
        <Stack direction="row" spacing={2} alignItems="center">
          {comment.closedAt && (
            <Typography color="textSecondary" fontSize="small" variant="caption">
              LUKKET
            </Typography>
          )}
          <Typography color="textSecondary" fontSize="small">
            {formatDateOnly(comment.createdAt)}
          </Typography>
        </Stack>
      </Stack>
      <Typography whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
        {comment.text}
      </Typography>
    </Stack>
  );
};
